import React from "react";
import { CheckCircle, WarningCircle } from "@phosphor-icons/react";
import ScoreDial from "./ScoreDial";
import { CATEGORY_ORDER, scoreTone } from "../../lib/clarity";

export default function ClarityPreview({ result }) {
  const cats = result.categories;
  const strength = CATEGORY_ORDER.map((k) => cats[k].strength).find(Boolean);
  const gap = result.gaps[0];
  return (
    <section data-testid="clarity-preview" className="grid lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-4 flex justify-center"><ScoreDial score={result.overall} size={220} testid="preview-score-dial" /></div>
      <div className="lg:col-span-8 space-y-6">
        <div>
          <p className="eyebrow">Your preview</p>
          <h2 data-testid="preview-band" className="font-display text-4xl sm:text-5xl mt-2">{result.band}</h2>
          {result.provisional && <p data-testid="preview-provisional" className="text-xs text-orange-300 mt-2">{result.confidence_label === "Low" ? `Low confidence — based on ${Math.round(result.confidence * 100)}% of applicable questions. Treat as a rough starting point.` : "Provisional — some answers were unknown or skipped."}</p>}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
          {CATEGORY_ORDER.map((k) => (
            <div key={k} data-testid={`preview-cat-${k}`} className="card-surface p-4">
              <p className="text-[10px] eyebrow text-exodus-muted leading-tight">{cats[k].label}</p>
              <p className={`font-display text-3xl mt-2 ${scoreTone(cats[k].score)}`}>{cats[k].score ?? "—"}</p>
            </div>
          ))}
        </div>
        <div className="space-y-3 text-sm">
          {strength && <p className="flex gap-2"><CheckCircle size={18} weight="fill" className="text-exodus-emerald shrink-0" />{strength}</p>}
          {gap && <p className="flex gap-2"><WarningCircle size={18} weight="fill" className="text-orange-300 shrink-0" />{gap.gap}</p>}
        </div>
      </div>
    </section>
  );
}
